import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import FormYearMonth from '../components/form-year-month';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { CourseModel, SignupModelHelper } from "../data/SignupModel";
import { dataLayerHelper } from "../data/dataLayerModel";
import { months } from '../data/months';
import AmarelinhoService from '../services/AmarelinhoService';

export default function CursosFim(props: any) {

  const [interactions, setInteractions] = useState<InteractionModel[]>([]);
  const [course, setCourse] = useState<CourseModel | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    TagManager.dataLayer(dataLayerHelper.pagina('fim-ano', 'cursos'));
    setCourse(SignupModelHelper.getOngoingCourse());
  }, [])

  function setLeaveYearMonth(yearMonth: string) {
    let chat: any = [];
    const startDate = new Date(course?.start!);
    const finishDate = new Date(yearMonth + "-01T12:00");
    const today = new Date();
    today.setHours(12);
    const maxYear = new Date().getFullYear();

    chat = [...interactions, {
      text: `${months[finishDate.getMonth()]} de ${finishDate.getFullYear()}`,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);

    if (isNaN(finishDate.getTime()) || finishDate.getFullYear() < 1900) {
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Informe um ano entre 1900 e ${maxYear}`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else if (startDate > finishDate) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `A data de conclusão deve ser no mesmo mês ou posterior ao de início.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else if (finishDate > today) {
      const nextMonth = new Date();
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Selecione um mês anterior a ${months[nextMonth.getMonth()]} de ${nextMonth.getFullYear()}.`
        }]);

        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else {
      SignupModelHelper.updateCourse({ finish: finishDate, saved: true });
      const signup = SignupModelHelper.get();
      if (signup) {
        setLoading(true)
        AmarelinhoService.saveCourses(signup).then((ret) => {
          setLoading(false);
          if (!ret.success) {
            setTimeout(() => {
              setInteractions([...chat, {
                author: InteractionAuthor.AMARELINHO,
                text: ret.message
              }]);
              setTimeout(() => {
                let chat = document.getElementsByClassName('chat')[0];
                chat.scrollTo(0, chat.scrollHeight);
              }, 500);
            }, 1000)
          } else {
            TagManager.dataLayer(dataLayerHelper.formEnviado('form_cursos'));
            SignupModelHelper.update({ courses: undefined });
            document.location = '#/idiomas-inicio';
          }
        })
      }
    }
  }



  return (
    <>
      <Header step={ 8 } total={ 8 } title="Cursos" previous="#/cursos-inicio"></Header>
      <FormYearMonth
        lastAnswer={`${months[new Date(course?.start!).getMonth()]} de ${new Date(course?.start!).getFullYear()}`}
        question="Agora, qual <strong>a data de término</strong>?"
        interactions={interactions}
        loading={loading}
        onSubmit={setLeaveYearMonth}
      />
    </>);
}
